/**
 * Copyright © 2026 Delicious AI, LLC
 */

import { gql } from '@apollo/client'

export const SEARCH_FLAG_REASON_OPTIONS = gql`
  query SearchFlagReasonOptions($type: FlaggedTypeChoices!, $query: String) {
    searchFlagReasonOptions(type: $type, query: $query) {
      id
      type
      reason
    }
  }
`
